module.exports = __webpack_public_path__ + "img/about-home-banner-1-test.a19b4de2.jpg";